






























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Component({
  directives: {
    clickOutside: {
      bind(el: any, binding: any) {
        el._clickOutside = (e: Event) => {
          if (!el.contains(e.target)) binding.value()
        }
        document.addEventListener('click', el._clickOutside)
      },
      unbind(el: any) {
        document.removeEventListener('click', el._clickOutside)
      }
    }
  }
})
export default class YearDropdown extends Vue {
  @Prop({ default: () => new Date().getFullYear() }) value!: number
  @Prop({ default: 2020 }) minYear!: number
  @Prop({ default: () => new Date().getFullYear() }) maxYear!: number
  @Prop({ default: true }) fixed!: boolean

  isOpen: boolean = false


  get yearOptions() {
    const years = []
    for (let y = this.minYear; y <= this.maxYear; y++) {
      years.push({ value: y, text: String(y) })
    }
    return years
  }

  get selectedYear() {
    return this.value
  }

  set selectedYear(year: number) {
    this.$emit('input', year)
  }

  select(year: number) {
    this.selectedYear = year
    this.isOpen = false
  }

  close() {
    this.isOpen = false
  }

}
